import { ignoreErrors } from "@lib/error/sentry/rules";
import * as Sentry from "@sentry/react";
import * as React from "react";
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from "react-router-dom";

export function initSentry(
  options: Partial<Sentry.BrowserOptions> & { release: string },
) {
  Sentry.init({
    normalizeDepth: 10,
    dsn: window.config.url.sentry,
    environment: window.config.environment,
    allowUrls: ["groupemutuel.ch"],
    ignoreErrors,
    tracesSampleRate: 0.2,
    tracePropagationTargets: ["entreprises.groupemutuel.ch"],
    integrations: [
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect: React.useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
    ],
    // specific options for ece or adm
    ...options,
  });

  window.addEventListener("error", (event) => {
    Sentry.captureException(event.error);
  });
}
